module.exports = __webpack_public_path__ + "img/corners_bak.8975d8a.png";